import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { GeoServices } from '../../services/geo.service';
import { SecurityService } from '../../services/security.service';
import { CryptoService } from '../../services/crypto.service';
import { TranslateService } from 'ng2-translate';

@Injectable()
export class UserProfileService {

    constructor(
        public _geoServices: GeoServices,
        public _securityService: SecurityService,
        public _cryptoService: CryptoService,
        private _translateService: TranslateService
    ) { }

    public checkUserLoginAviability(login: string, userId: number) {
        let obs: Observable<Object> = Observable.of({ value: null });

        if (login != '') {
            let requestParams = {
                '{login}': login,
                '{id}': userId
            };

            obs = this._geoServices.doRequestUriKey('common_user_check_login_url', 'POST', undefined, requestParams, undefined, undefined, this._translateService.instant('user-profile.notifications.user'), this._translateService.instant('user-profile.notifications.unicity'))
                .map((res) => this._geoServices.extractData(res))
                .catch(this._geoServices.handleError.bind(this._geoServices))
                .share();
        }

        return obs;
    }

    public checkUserPasswordAvailability(password: string, userId: number, salt: string) {
        let obs: Observable<Object> = Observable.of({ value: null });

        if (password != '') {
            let securityConfig = this._securityService.get('user');
            let requestParams = {
                '{password}': this._cryptoService.encode(password, securityConfig, salt),
                '{id}': userId
            };

            obs = this._geoServices.doRequestUriKey('common_user_check_password_history_url', 'POST', undefined, requestParams, undefined, undefined, this._translateService.instant('user-profile.notifications.user'), this._translateService.instant('user-profile.notifications.unicity'))
                .map((res) => this._geoServices.extractData(res))
                .catch(this._geoServices.handleError.bind(this._geoServices))
                .share();
        }

        return obs;
    }

    /**
     * Check password availability for a user that provides a password revoery token
     * Check available for users that are not logged in
     * @param password
     * @param token
     * @param salt
     */
    public checkUserPasswordAvailabilityWithToken(password: string, token: string, salt: string) {
        let obs: Observable<Object> = Observable.of({ value: null });

        if (password != '') {
            let securityConfig = this._securityService.get('user');
            let requestParams = {
                '{password}': this._cryptoService.encode(password, securityConfig, salt),
                '{token}': token
            };

            obs = this._geoServices.doRequestUriKey(
                'common_user_token_check_password_history_url',
                'GET',
                undefined,
                requestParams,
                undefined,
                undefined,
                this._translateService.instant('user-profile.notifications.user'),
                this._translateService.instant('user-profile.notifications.unicity')
            )
            .map((res) => this._geoServices.extractData(res))
            .catch(this._geoServices.handleError.bind(this._geoServices))
            .share();
        }

        return obs;
    }

    public getPasswordConfirmPattern(passw){
        return passw ? passw.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : '';
    }

    public encryptUserInformations(userObj: any) {
        let securityConfig = this._securityService.get('user');

        // Si le user n'a pas de salt , on lui créer
        if (!userObj.user_passw_salt) {
            userObj.user_passw_salt = this._cryptoService.getSalt(8).toString();
        }

        // Si mot de passe , on les crypte
        if (userObj.passw) {
            userObj.passw = this._cryptoService.encode(userObj.passw, securityConfig, userObj.user_passw_salt);
        }
        if (userObj.passwConfirm) {
            userObj.passwConfirm = this._cryptoService.encode(userObj.passwConfirm, securityConfig, userObj.user_passw_salt);
        }
    }

    public updateUser(userId: number, userObj: any):Observable<any> {
        this.encryptUserInformations(userObj);

        let requestParams = {
            '{id}': userId
        };

        let obs = this._geoServices.doRequestUriKey('common_user_url', 'PUT', undefined, requestParams, userObj, undefined, this._translateService.instant('user-profile.notifications.user'), this._translateService.instant('user-profile.notifications.modifications'))
            .map((res) => this._geoServices.extractData(res))
            .catch(this._geoServices.handleError.bind(this._geoServices))
            .share();

        return obs;
    }

    public updateUserEmail(userId: number, email: string):Observable<any> {
        let requestParams = {
            '{id}': userId
        };

        let datas = {
            'email': email
        };

        let obs = this._geoServices.doRequestUriKey('common_user_email_url', 'PUT', undefined, requestParams, datas, undefined, this._translateService.instant('user-profile.notifications.user'), this._translateService.instant('user-profile.notifications.modifications'))
            .map((res) => this._geoServices.extractData(res))
            .catch(this._geoServices.handleError.bind(this._geoServices))
            .share();

        return obs;
    }

    public getUserLdapLogin(userId: number) {

        let requestParams = {
            '{id}': userId
        };

        let obs = this._geoServices.doRequestUriKey(
            'common_user_get_ldap_login_url',
            'GET',
            undefined,
            requestParams,
            undefined,
            undefined,
            this._translateService.instant('user-profile.notifications.ldap'),
            this._translateService.instant('user-profile.notifications.ldap')
        )
        .map((res) => this._geoServices.extractData(res))
        .catch(this._geoServices.handleError.bind(this._geoServices))
        .share();

        return obs;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/user-profile/user-profile.service.ts